import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ParagraphSelectors from './paragraph.selectors';

@Injectable({
  providedIn: 'root',
})
export class ParagraphFacade {
  private readonly store: Store = inject(Store);

  public readonly paramParagraphId: Signal<string | undefined> =
    this.store.selectSignal(ParagraphSelectors.selectParamParagraphId);
  public readonly fullyLoadedIds: Signal<string[]> = this.store.selectSignal(
    ParagraphSelectors.selectParagraphFullyLoadedIds,
  );
  public readonly paramParagraphLoaded: Signal<boolean> =
    this.store.selectSignal(ParagraphSelectors.selectParamParagraphLoaded);
}
